// TODO 预付款API
import {request} from '../jslib/request'
import axios from 'axios'
const BASE_REQUEST = '/bms/customer-advance-payment-account'

/** 预付款客户列表 */
export function getList(data) {
  return request({
    url: `${BASE_REQUEST}/list`,
    method: 'get',
    data
  })
}

/** 预付款订单列表 */
export function getDetailList(data) {
  return request({
    url: `${BASE_REQUEST}/detail/list`,
    method: 'get',
    data
  })
}

/** 预付款流水列表 */
export function getWaterList(data) {
  return request({
    url: `${BASE_REQUEST}/water/list`,
    method: 'get',
    data
  })
}

export function queryCharge(querydata) {
  return request({
    url:`${BASE_REQUEST}/queryCharge`,
    data:querydata
  })
}

export function isExistAccount(customerId) {
  return request({
    url: `${BASE_REQUEST}/isExistAdvancePaymentAccountByCustomerId`,
    method: 'get',
    data:{
      customerId
    }
  })
}
